export class EmailDetail {
  public emailId: number;
  public eventId: string;
  public recipientTo: string;
  public recipientCC: string;
  public subject: string;
  public bodyText: string;
  public sentBy: string;
  public sentTime: Date;
  public attachmentName: string;
  public attachmentType: string;
  public iconClass?: string;
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/communication/model/email-detail.model.ts